import { render, staticRenderFns } from "./season-card-button.vue?vue&type=template&id=2875b2a1"
import script from "./season-card-button.vue?vue&type=script&lang=js"
export * from "./season-card-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports